import { Skeleton } from '@/shared/ui/Skeleton';
import skeletonStyles from './LearningSkeleton.module.css';

export function LearningSkeleton() {
  return (
    <div className={skeletonStyles.container} data-testid="learning-skeleton">
      {/* Header: badge row + title + description */}
      <header className={skeletonStyles.header}>
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-3)', marginBottom: 'var(--spacing-4)' }}
        >
          <Skeleton width={40} height={40} borderRadius="var(--radius-lg)" />
          <Skeleton width={120} height={16} />
        </div>
        <Skeleton width="45%" height={36} style={{ marginBottom: 'var(--spacing-4)' }} />
        <Skeleton width="65%" height={20} />
      </header>

      <section className={skeletonStyles.sectionsList}>
        {/* Resources & Toolkits Skeleton */}
        <div>
          <div className={skeletonStyles.sectionHeader}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton width={200} height={24} />
          </div>
          <div className={skeletonStyles.carousel}>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={skeletonStyles.resourceCard}>
                <Skeleton height={160} />
                <div className={skeletonStyles.resourceContent}>
                  <Skeleton width="80%" height={20} style={{ marginBottom: 'var(--spacing-2)' }} />
                  <Skeleton width="40%" height={16} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Workshop Library Skeleton */}
        <div>
          <Skeleton width={180} height={24} style={{ marginBottom: 'var(--spacing-6)' }} />
          <div className={skeletonStyles.carousel}>
            {[1, 2, 3].map((i) => (
              <div key={i} className={skeletonStyles.workshopCard}>
                <Skeleton height={180} />
                <div className={skeletonStyles.workshopContent}>
                  <Skeleton width="90%" height={20} style={{ marginBottom: 'var(--spacing-2)' }} />
                  <Skeleton width="30%" height={16} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
